import { ReactNode } from 'react'
import { Box } from '@mui/material'

/**
 * A grid's action band for grids that drive a job rather than edit cells
 * (template generation, safety stock): the GridToolbar's panel-head band,
 * joined to the grid below it — give that grid square top corners. Left:
 * edit actions. Right: a one-line hint, then the actions.
 */
export const GridActionBar = ({
  left,
  hint,
  children,
}: {
  left?: ReactNode
  hint?: ReactNode
  children?: ReactNode
}) => (
  <Box
    sx={{
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
      minHeight: 40,
      px: '8px',
      py: '6px',
      background: 'var(--panel-head)',
      border: '1px solid var(--line-200)',
      borderBottom: 'none',
      borderRadius: 'var(--radius-md) var(--radius-md) 0 0',
    }}
  >
    {left}
    <Box sx={{ flex: 1 }} />
    {hint && <Box sx={{ fontSize: 12, color: 'var(--ink-500)' }}>{hint}</Box>}
    {children}
  </Box>
)

/** Square top corners for the grid under a GridActionBar. */
export const JOINED_GRID_SX = {
  borderTopLeftRadius: 0,
  borderTopRightRadius: 0,
} as const
